module.exports = __webpack_public_path__ + "img/app-store.3f6dc5f5.svg";